exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1bJ7G{position:absolute;z-index:100;top:0;right:0;bottom:0;left:0;display:none}._1bJ7G._7Tkkg{display:-webkit-box;display:-ms-flexbox;display:flex}._1bJ7G._7Tkkg,._88Hqt{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._88Hqt{right:0;bottom:0;background:#000 no-repeat 50%;background-size:cover}._88Hqt,._88Hqt:before{position:absolute;top:0;left:0;width:100%;height:100%}._88Hqt:before{content:\"\";background-color:rgba(0,0,0,.35)}._3Npj1{position:relative;width:71px;height:71px;cursor:pointer;opacity:1}._3Npj1:hover{opacity:.8}.LeBLo{fill:#fff}._1yX8H{stroke:#fff}", ""]);

// exports
exports.locals = {
	"overlay": "_1bJ7G",
	"active": "_7Tkkg",
	"poster": "_88Hqt",
	"icon": "_3Npj1",
	"svgFill": "LeBLo",
	"svgStroke": "_1yX8H"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--10-1!../node_modules/postcss-loader/lib??ref--10-2!../node_modules/sass-loader/lib/loader.js??ref--10-3!./ui/overlay.scss
// module id = 222
// module chunks = 0